import { Observable } from 'rxjs';
import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '@wgu-edu/wgu-core';


@Component({
  templateUrl: './template/updateAccount.component.html',
  styles: [`
    em { float:right; color:#E05C65; padding-left:10px; }
  `]
})
export class UpdateAccountComponent {
  isAuthenticated$: Observable<boolean>;
  
  constructor(  private authService: AuthService, private router: Router) {
    this.isAuthenticated$ = this.authService.isAuthenticated$;
    // console.log("User isAuthenticated: " + this.isAuthenticated$)
  }
  authenticationQuestions(){
    //this.router.navigate(['identityiq/external/forgotPassword/authenticationQuestions'])
  }
}
